import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Modal,
  Avatar,
  Badge,
  Card,
  notification,
  Button,
  Popover,
  Divider,
  Switch,
} from "antd";
import Amplify, { Auth } from "aws-amplify";
import AwsConfig from "../config/AwsConfig";
import loginLogo2 from "../images/loginLogo2.png";
import {
  update,
  getDetails,
  list,
  noAuthgetDetails,
  noAuthlist,
} from "../api/Apis";
import { withAppContext } from "../store/contextStore";
import {
  LoginOutlined,
  LogoutOutlined,
  HeartFilled,
  UserOutlined,
  ShopOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import Notifications from "./Notifications";
import moment from "moment";
const { Meta } = Card;
Amplify.configure(AwsConfig);

class HeaderMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: "",
      searchType:
        localStorage.getItem("searchType") != null
          ? localStorage.getItem("searchType")
          : "Homes",
      newUserDetails: "",
      Favorites: [],
      loading: false,
      showVendorConfirmation: false,
    };
  }

  componentDidMount() {
    this.getFourStatesCode();
    this.props.context.setLoading(true);
    Auth.currentUserInfo()
      .then((user) => {
        if (user) {
          let userId = user.username;
          if (user.username.indexOf("Facebook") > -1) {
            userId = user.attributes?.sub;
          }
          if (user.username.indexOf("Google") > -1) {
            userId = user.attributes?.sub;
          }
          if (user.username !== undefined && user.username !== null) {
            this.getUserProfile(userId);
          }
        }
      })
      .catch((err) => console.log(err, "erorr"));
  }

  getFourStatesCode = () => {
    try {
      const dataObj = { dataType: "apiConfig" };
      noAuthlist("getConfigData", dataObj)
        .then((stateCodes) => {
          if (stateCodes.success) {
            localStorage.setItem(
              "stateCodesFromAdmin",
              JSON.stringify(stateCodes.data)
            );
          }
        })
        .catch((err) => console.log(err));
    } catch (error) {
      alert("Something went wrong");
    }
  };

  getUserProfile = async (id) => {
    let newUserDetails = {};
    noAuthgetDetails("getUsers", id).then(async (result) => {
      if (result.success) {
        if (result.data.profilePicture) {
          const profileUrl =
            `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` +
            result.data.profilePicture[0];
          result.data["profileUrl"] = profileUrl;
          newUserDetails = { ...result.data };
          this.props.context.setUserDetails(newUserDetails);
          this.setState({ userDetails: newUserDetails });
        } else {
          this.props.context.setUserDetails(result.data);
          this.setState({ userDetails: result.data });
        }
        this.props.context.setLoading(false);
      } else {
        console.log(result.errors);
      }
    });

    const userId = id;
    try {
      const getFavorites = await list("userFavorites", { userId: userId });
      if (getFavorites.success) {
        this.setState({ Favorites: getFavorites.data });
        this.props.context.handleFavoritesCount(
          this.state.Favorites,
          this.state.Favorites.length
        );
      }
    } catch (error) {
      notification["error"]({ message: "Something went wrong" });
      window.location.assign("/pageNotFound/newtWork");
    }

    this.setState({ loading: false, showVendorConfirmation: false });
  };

  handleClear = () => {
    window.location.reload();
  };

  handleLogout = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let currentDate = moment(new Date()).format("MM/DD/YYYY");
    let userLoginTime = localStorage.getItem("userLoginTime");
    let userLogoutTime = new Date().getTime();
    var diffMs = userLogoutTime - userLoginTime;
    var diffDays = Math.floor(diffMs / 86400000);
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    let diffTime = { Days: diffDays, Hours: diffHrs, Mins: diffMins };
    let totalVisits =
      userDetails && userDetails.totalVisits ? userDetails.totalVisits : [];
    totalVisits?.map((p) => {
      let totalTime = p.totalTime ? p.totalTime : [];
      if (p.check_today_date === currentDate) {
        totalTime.push(diffTime);
        p["totalTime"] = totalTime;
      }
      return p;
    });

    let data = { entityData: { totalVisits } };
    await update("users", userDetails.id, data);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    try {
      await Auth.signOut()
        .then((res) => {
          localStorage.setItem("userDetails", JSON.stringify(""));
          localStorage.setItem("subscriptionPack", JSON.stringify(""));
          localStorage.removeItem("userLogin");
          localStorage.removeItem("userLoginTime");
          this.props.context.setUserDetails("");
          this.props.context.setUser("");
          this.props.context.setUserLogin(false);
          localStorage.removeItem("signupUserSelectedProfile");
          localStorage.removeItem("facebookAccessToken");
          localStorage.removeItem("fbUserProfilePic");
          window.location.replace("/login");
        })
        .catch((error) => {
          console.log("error signing out: ", error);
          window.location.replace("/login");
        });
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  setLoading = () => {
    this.props.context.setLoading(true);
  };

  setFilterSearchEmpty = () => {
    const filterdata = [];
    this.props.context.setFilterData(filterdata);
    this.props.context.setAgentFilterSearch(filterdata);
    localStorage.removeItem("selectedCities");
    localStorage.removeItem("filterSearchData");
    this.props.context.handleToSetCurrentPage(1, 10);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  handleLink = async () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  handleMyProfile = () => {
    const { userDetails } = this.state;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (window.location.href === this.props.context?.state?.page_pathname) {
      window.location.assign(`/viewProfile/${userDetails.id}`);
    }
  };

  handleCancel = () => {
    this.setState({ loading: false, showVendorConfirmation: false });
  };

  changeProfile = async () => {
    this.setState({ loading: true });
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const newUpdatedData = await getDetails("users", userDetails.id);
    if (newUpdatedData && newUpdatedData.data && newUpdatedData.data.newdata) {
      const newdata = newUpdatedData.data.newdata;
      newdata["zipCodes"] = [];
      newdata["Specialties"] = [];
      const data = {
        entityData: { userProfile: "V", newdata: newdata },
      };
      this.updateProfileData(data, userDetails.id);
    } else {
      const data = { entityData: { userProfile: "V" } };
      this.updateProfileData(data, userDetails.id);
    }
  };

  updateProfileData = async (data, userId) => {
    const updatingUserDetails = await update("users", userId, data);
    if (updatingUserDetails.success) {
      this.getUserProfile(userId);
      notification["success"]({
        message: "You have successfully changed your profile. Thank you.",
      });
    } else {
      this.getUserProfile(userId);
      notification["error"]({
        message: "Somethig Went Wrong",
        description: "Please try again",
      });
    }
  };

  /* ─── shared avatar source helper ─── */
  getAvatarSrc = (fbUserProfile) => {
    if (fbUserProfile !== null) return fbUserProfile;
    const { userDetails } = this.state;
    if (
      this.props.context.state.userDetails &&
      this.props.context.state.userDetails.profilePicture
    ) {
      return (
        `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` +
        this.props.context.state.userDetails.profilePicture[0]
      );
    }
    return (
      <Button
        shape="circle"
        size="large"
        block={true}
        className="header-img-btn"
      >
        {userDetails.firstName && userDetails.firstName.charAt(0).toUpperCase()}
      </Button>
    );
  };

  /* ─── shared profile popover content ─── */
  renderPopoverContent = () => {
    const { userDetails, showVendorConfirmation } = this.state;
    const { data1, authenticate, count, currentPage } = this.props;
    let fbUserProfile = JSON.parse(localStorage.getItem("fbUserProfilePic"));

    return (
      <div style={{ width: "200px" }}>
        {/* User identity card at top of popover — same as original */}
        <Meta
          avatar={
            <Avatar src={this.getAvatarSrc(fbUserProfile)} />
          }
          title={
            userDetails.firstName
              ? `${userDetails.firstName} ${userDetails.lastName}`
              : userDetails.fullName
          }
          description={
            userDetails.userProfile === "B"
              ? "Buyer"
              : userDetails.userProfile === "S"
              ? "Seller"
              : userDetails.userProfile === "AG"
              ? "Agent"
              : userDetails.userProfile === "V"
              ? "Vendor"
              : "Lender"
          }
        />
        <Divider style={{ marginBottom: "1vw", marginTop: "1vw" }} />

        <Row style={{ cursor: "pointer", marginBottom: "10px" }}>
          <Col>
            <UserOutlined style={{ fontSize: "14px", marginRight: "10px" }} />
          </Col>
          <Col>
            <Link
              to={{
                pathname: `/viewProfile/${userDetails.id}`,
                state:
                  userDetails.userProfile === "AG"
                    ? "Agents"
                    : userDetails.userProfile === "V"
                    ? "Vendor"
                    : userDetails.userProfile === "L"
                    ? "Lender"
                    : userDetails.userProfile === "B"
                    ? "Buyer"
                    : "Seller",
              }}
              style={{ textDecoration: "none", color: "black", fontSize: "16px" }}
              onClick={this.handleMyProfile}
            >
              My Tools
            </Link>
          </Col>
        </Row>

        {userDetails.userProfile === "B" || userDetails.userProfile === "S" ? (
          <Row style={{ cursor: "pointer", marginBottom: "10px" }}>
            <Col>
              <ShopOutlined style={{ fontSize: "14px", marginRight: "10px" }} />
            </Col>
            <Col>
              <span style={{ color: "black", fontSize: "16px" }}>
                Enable Vendor
              </span>
            </Col>
            <Col style={{ marginLeft: "5px" }}>
              <Switch
                checked={showVendorConfirmation}
                checkedChildren="Yes"
                unCheckedChildren="No"
                onClick={() =>
                  this.setState({
                    showVendorConfirmation: !showVendorConfirmation,
                  })
                }
              />
            </Col>
          </Row>
        ) : userDetails.userProfile === "L" || userDetails.userProfile === "V" ? (
          <Row style={{ cursor: "pointer", marginBottom: "10px" }}>
            <Col>
              <ShopOutlined style={{ fontSize: "14px", marginRight: "10px" }} />
            </Col>
            <Col>
              <Link
                to={{
                  pathname: `/sellerBuyer/viewProfile/${userDetails.id}`,
                  state: {
                    userDetails,
                    data: data1,
                    authenticate,
                    currentPage,
                    count,
                  },
                }}
                style={{ textDecoration: "none", color: "black", fontSize: "16px" }}
                onClick={this.handleLink}
              >
                Seller/Buyer Profile
              </Link>
            </Col>
          </Row>
        ) : (
          <span />
        )}

        <Row style={{ cursor: "pointer", marginBottom: "10px" }}>
          <Col>
            <SettingOutlined style={{ fontSize: "14px", marginRight: "10px" }} />
          </Col>
          <Col>
            <Link
              to={{
                pathname: `/myProfile/${userDetails && userDetails.id}`,
                state: { userDetails, data: data1, authenticate, currentPage, count },
              }}
              onClick={this.handleLink}
              style={{ textDecoration: "none", color: "black", fontSize: "16px" }}
            >
              Profile Settings
            </Link>
          </Col>
        </Row>

        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

        <Row onClick={this.handleLogout} style={{ cursor: "pointer" }}>
          <Col>
            <LogoutOutlined style={{ color: "red", fontSize: "16px" }} />
          </Col>
          <Col
            style={{
              color: "red",
              fontSize: "16px",
              marginLeft: "10px",
              marginTop: "-3px",
            }}
          >
            Logout
          </Col>
        </Row>
      </div>
    );
  };

  /* ─── shared Meta avatar block ─── */
  renderMetaAvatar = (fbUserProfile, linkProps) => {
    const { userDetails } = this.state;
    const { data1, authenticate, count, currentPage } = this.props;

    return (
      <Link
        to={{
          pathname: linkProps.pathname,
          state: { userDetails, data: data1, authenticate, currentPage, count },
        }}
        style={{ textDecoration: "none" }}
        onClick={this.handleLink}
      >
        <Meta
          avatar={
            <Avatar src={this.getAvatarSrc(fbUserProfile)} />
          }
          title={
            userDetails.firstName
              ? `${userDetails.firstName} ${userDetails.lastName}`
              : userDetails.fullName
          }
          description={
            userDetails.userProfile === "B"
              ? "Buyer"
              : userDetails.userProfile === "S"
              ? "Seller"
              : userDetails.userProfile === "AG"
              ? "Agent"
              : userDetails.userProfile === "V"
              ? "Vendor"
              : "Lender"
          }
        />
      </Link>
    );
  };

  render() {
    const { userDetails, showVendorConfirmation, loading } = this.state;
    let userLogin = localStorage.getItem("userLogin");
    let fbUserProfile = JSON.parse(localStorage.getItem("fbUserProfilePic"));

    const profileLinkPath =
      userDetails && userDetails.userProfile === "AG"
        ? `/viewProfile/${userDetails && userDetails.id}`
        : `/myProfile/${userDetails && userDetails.id}`;

    return (
      <div className="header">
        {/* ── Mobile / Tablet sidebar header (hidden on ≥ 993px) ── */}
        <div
          className="header-sidebar"
          style={{ background: userLogin ? "#3045d2" : "white" }}
        >
          <header className="header-nav navbar-fixed-top">
            <nav className="navbar" role="navigation">
              {userLogin ? (
                <Row justify="space-between" align="middle">
                  <Col span={12}>
                    <Link to="/homes" onClick={this.handleLink}>
                      <img
                        src={loginLogo2}
                        alt="logo"
                        className="logo-header logo-header--mobile"
                      />
                    </Link>
                  </Col>
                  <Col span={12} style={{ padding: "8px 10px" }}>
                    <Row justify="end" align="middle" gutter={[8, 0]}>
                      <Col className="notify-col notify-col--icons">
                        <Link
                          to={`/favourties/${userDetails.id}`}
                          onClick={this.handleLink}
                          className="heart-col"
                        >
                          <Badge>
                            <HeartFilled className="heart-header" />
                          </Badge>
                        </Link>
                      </Col>
                      <Col className="notify-col notify-col--icons">
                        {userDetails && userDetails.id && (
                          <Notifications userId={userDetails.id} />
                        )}
                      </Col>
                      <Col className="profile-height">
                        <Popover
                          placement="bottomRight"
                          content={this.renderPopoverContent()}
                          title={null}
                          trigger="hover"
                        >
                          <Avatar
                            className="avatar-img-header"
                            src={this.getAvatarSrc(fbUserProfile)}
                          />
                        </Popover>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                  <Col span={12}>
                    <Link to="/" onClick={this.handleLink}>
                      <img
                        src={loginLogo2}
                        alt="logo"
                        className="logo-header logo-header--mobile"
                      />
                    </Link>
                  </Col>
                  <Col span={12} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: "16px" }}>
                    <Link
                      to="/login"
                      onClick={this.handleLink}
                      style={{ cursor: "pointer" }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <LoginOutlined
                          style={{ fontSize: "18px", color: "black" }}
                        />
                        <span style={{ fontSize: "18px", color: "black" }}>
                          Login
                        </span>
                      </div>
                    </Link>
                  </Col>
                </Row>
              )}
            </nav>
          </header>
        </div>

        {/* ── Desktop header (hidden on ≤ 992px) ── */}
        <Row
          className="desktop-header-row"
          style={{
            background: userLogin
              ? "#3045D2 0% 0% no-repeat padding-box"
              : "#fff 0% 0% no-repeat padding-box",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
            height: "80px",
          }}
        >
          {/* Logo — fixed width, never shrinks */}
          <Col
            className="header-logo-class"
            style={{ flexShrink: 0, flexGrow: 0 }}
          >
            <Link to={userLogin ? "/homes" : "/"} onClick={this.handleLink}>
              <img
                src={loginLogo2}
                alt="MyHomeBuddha Logo"
                className="logo-header"
              />
            </Link>
          </Col>

          {/* Nav Links — grows to fill available space, clips before touching logo or right section */}
          <div
            className="display-flex-end header-nav-links"
            style={{
              flex: "1 1 0",
              minWidth: 0,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "nowrap",
            }}
          >
            {[
              { to: "/homes", label: "Home Search" },
              { to: "/offMLSHomes", label: "OFF MLS Search" },
              { to: "/buyers", label: "Buyer Profiles" },
              { to: "/agent", label: "Agents" },
              { to: "/lenders", label: "Lenders" },
              { to: "/marketplace", label: "Marketplace" },
            ].map(({ to, label }) => (
              <div key={to} style={{ flexShrink: 0 }}>
                <Link to={to}>
                  <span
                    className="header-menu-titles"
                    style={{
                      color:
                        window.location.pathname === to
                          ? "#fd7e14"
                          : userLogin
                          ? "#FFF"
                          : "black",
                    }}
                    onClick={() => {
                      this.setFilterSearchEmpty();
                      this.handleLink();
                    }}
                  >
                    {label}
                  </span>
                </Link>
              </div>
            ))}

            <div style={{ flexShrink: 0 }}>
              <a
                href="https://myhomebuddha.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  className="header-menu-titles"
                  style={{ color: userLogin ? "#FFF" : "black" }}
                  onClick={() => {
                    this.setFilterSearchEmpty();
                    this.handleLink();
                  }}
                >
                  Learn More
                </span>
              </a>
            </div>

            <div style={{ flexShrink: 0 }}>
              <Link
                to={{ pathname: "https://go.myhomebuddha.com/aboutus" }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  this.setFilterSearchEmpty();
                  this.handleLink();
                }}
              >
                <span
                  className="header-menu-titles"
                  style={{
                    color:
                      window.location.pathname === "/about"
                        ? "#fd7e14"
                        : userLogin
                        ? "#FFF"
                        : "black",
                  }}
                >
                  About Us
                </span>
              </Link>
            </div>

            <div style={{ flexShrink: 0 }}>
              <Link to="/contactUs" onClick={this.handleLink}>
                <span
                  className="header-menu-titles"
                  style={{
                    color:
                      window.location.pathname === "/contactUs"
                        ? "#fd7e14"
                        : userLogin
                        ? "#FFF"
                        : "black",
                  }}
                  onClick={() => {
                    this.setFilterSearchEmpty();
                    this.handleLink();
                  }}
                >
                  Contact Us
                </span>
              </Link>
            </div>

            {/* Kept commented as in original — uncomment to restore
            <Col>
              <Link to="/whyJoinUs" onClick={this.handleLink}>
                <span
                  className="header-menu-titles"
                  style={{
                    color:
                      window.location.pathname === "/whyJoinUs"
                        ? "#fd7e14"
                        : userLogin
                        ? "#FFF"
                        : "black",
                  }}
                  onClick={() => {
                    this.setFilterSearchEmpty();
                    this.handleLink();
                  }}
                >
                  Why Join Us
                </span>
              </Link>
            </Col>
            */}
          </div>

          {/* Right: favorites, notifications, profile — fixed width, always flush right */}
          <div
            className="favourties-header"
            style={{
              flexShrink: 0,
              flexGrow: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              paddingRight: "20px",
              gap: "16px",
              marginLeft: "auto",
            }}
          >
            {userLogin ? (
              <>
                <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                  <Link
                    to={`/favourties/${userDetails.id}`}
                    onClick={this.handleLink}
                  >
                    <Badge>
                      <HeartFilled className="heart-header" />
                    </Badge>
                  </Link>
                </div>

                <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                  {userDetails && userDetails.id && (
                    <Notifications userId={userDetails.id} />
                  )}
                </div>

                <div
                  className="header-profile font-family-style color-white"
                  style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
                >
                  <Popover
                    placement="bottomRight"
                    content={this.renderPopoverContent()}
                    title={null}
                    trigger="hover"
                  >
                    {this.renderMetaAvatar(fbUserProfile, {
                      pathname: profileLinkPath,
                    })}
                  </Popover>
                </div>
              </>
            ) : (
              <>
                <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                  <Link
                    to="/login"
                    style={{ textDecoration: "none" }}
                  >
                    <span
                      className="header-menu-titles"
                      style={{ color: userLogin ? "#FFF" : "black" }}
                    >
                      Login
                    </span>
                  </Link>
                </div>
                <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                  <Button
                    className="font-family-style text-size1"
                    type="primary"
                    onClick={() => this.props.history.push("/register")}
                    danger
                  >
                    Join for free
                  </Button>
                </div>
              </>
            )}
          </div>
        </Row>

        {/* ── Vendor confirmation modal ── */}
        <Modal
          className="modal-black-close"
          visible={showVendorConfirmation}
          title="Vendor profile change request"
          onOk={() => this.changeProfile()}
          onCancel={() => this.setState({ showVendorConfirmation: false })}
          footer={[
            <Button
              key="back"
              onClick={() => this.setState({ showVendorConfirmation: false })}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={() => this.changeProfile()}
            >
              Proceed
            </Button>,
          ]}
        >
          <p style={{ padding: "10px", textAlign: "justify" }}>
            Vendor profiles are for professionals who own a business that
            provides services in and around real estate purchases, sales, and
            home maintenance/repair. By changing your profile to a vendor, your
            business will be listed on the marketplace page (with a basic
            subscription) where consumers and agents will be able to find you
            and seek out your services. Please confirm to proceed.
          </p>
        </Modal>
      </div>
    );
  }
}

export default withAppContext(withRouter(HeaderMenu));